import { action, computed, observable, toJS } from 'mobx'
import omitBy from 'lodash/omitBy'
import isNil from 'lodash/isNil'
import isEqual from 'lodash/isEqual'
import uuid from 'uuid'
import { statisticsService } from '../../api/statistics/statistics'
import { withSpinner } from '../with-spinner'

export class ViolationLogStore {
    @observable
    filters

    @observable
    errorCodes = []

    @observable
    errors = []

    @observable
    total

    @observable
    noSearchProceeded = true

    // Нужен для принудительной перерисовки uncontrolled фильтров
    @observable
    filtersKey

    @computed
    get filtersEmpty() {
        return isEqual(toJS(this.filters), this.emptyFilters)
    }

    emptyFilters = {
        dateFrom: null,
        dateTo: null,
        cash: null,
        errorCode: null,
        barcode: '',
    }

    constructor() {
        this.initFilters()
        this.filtersKey = uuid()
    }

    @action
    fetchErrorCodes = async () => {
        this.errorCodes = await withSpinner(statisticsService.getErrorCodes()) || []
    }

    @action
    initFilters = () => {
        this.filters = {
            dateFrom: new Date(new Date().setHours(0, 0, 0, 0)).getTime(),
            dateTo: new Date(new Date().setHours(23, 59, 59, 999)).getTime(),
            cash: null,
            errorCode: null,
            barcode: '',
        }
        this.filtersKey = uuid()
    }

    @action
    clearFilters = () => {
        this.filters = this.emptyFilters
        this.filtersKey = uuid()
    }

    @action
    updateFilters = changes => {
        if (isNil(changes)) return

        Object.keys(changes).forEach(key => {
            if (key in this.filters) {
                this.filters[key] = changes[key]
            }
        })
    }

    @action
    applyFilters = async () => {
        const appliedFilters = omitBy(
            toJS(this.filters),
            filterValue => isNil(filterValue) || filterValue === ''
        )

        const response = await withSpinner(statisticsService.getErrorLog(appliedFilters))

        if (response) {
            this.total = response.total
            this.errors = response.items
        } else {
            this.total = undefined
            this.errors = []
        }

        this.noSearchProceeded = false
    }

    @action
    reset = () => {
        this.clearFilters()
        this.errors = []
        this.total = undefined
        this.noSearchProceeded = true
    }
}
